/* src/app/right-menu/right-menu.component.scss */
/*# sourceMappingURL=right-menu.component.css.map */
